const wrapLinkForAnimation = ({
  element
}) => {
  const isSlotContent = element.querySelector("slot") || element instanceof HTMLSlotElement;
  const link = element instanceof HTMLAnchorElement ? element : element.querySelector("a");
  if (isSlotContent) return;
  if (!link) return;
  const isLinkSpan = link.querySelector("span");
  if (!isLinkSpan) {
    const span = document.createElement("span");
    span.innerHTML = link.innerHTML;
    link.innerHTML = "";
    link.appendChild(span);
  }
};
export {
  wrapLinkForAnimation
};
//# sourceMappingURL=wrapLinkForAnimation.js.map
